import {HubProxy, HubProxyFactory} from '../../modules/HubProxyModule';


export default class DebugController {
    datas = [];
    hub: HubProxy;
    invokeCommand: string;
    invokeParamsJson: string;
    result;


    constructor(hubProxyFactory: HubProxyFactory, private $location: ng.ILocationService) {
        this.hub = hubProxyFactory.create('DataHub', true);
        this.hub.onStateChanged(this.stateChanged);
        this.hub.on('noop', () => {});
        this.hub.connection.received((e) => this.datas.push(e));


    }


    stateChanged = (change: SignalR.StateChanged) => {
        this.datas = [];
        switch (change.newState) {
            case SignalR.ConnectionState.Connected:
                break;
        }
    };



    get invokeParamsObj() {
        try {
            var p = JSON.parse(this.invokeParamsJson);
            if (p && !Array.isArray(p))
                p = [p];
            else
                p = [];
            p.unshift(this.invokeCommand);
            return p;
        } catch (e) {
            return 'invalid json'
        }
    }

    invoke() {
        this.hub.invoke.apply(this.hub, this.invokeParamsObj)
            .then(e => this.result = e)
            .catch(e => this.result = e);
    }


}
